module.exports = __webpack_public_path__ + "static/media/Tropical-day.70818e35.svg";